export default {
  translation: {
    nav: {
      home: 'Inicio',
      trips: 'Viajes',
      aboutUs: 'Sobre Nosotros',
      alerts: 'Alertas',
      wishlist: 'Favoritos',
      language: 'Idioma',
      profile: 'Perfil',
      settings: 'Configuración',
      signIn: 'Iniciar Sesión',
      signUp: 'Registrarse'
    },
    hero: {
      title: 'Explora Uganda',
      subtitle: 'y más allá',
      description: 'Descubre la Perla de África con guías locales expertos. Experiencias inolvidables te esperan en los impresionantes paisajes y la vibrante cultura de Uganda.',
      searchPlaceholder: '¿A dónde vas?',
      categories: {
        all: 'Todo',
        wildlife: 'Vida Silvestre',
        safari: 'Safari',
        cultural: 'Cultural',
        adventure: 'Aventura',
        birding: 'Avistamiento de Aves'
      }
    },
    common: {
      from: 'desde',
      reviews: 'reseñas',
      viewMore: 'Ver más',
      book: 'Reservar',
      seeAll: 'Ver todo',
      loading: 'Cargando...'
    }
  }
};